/* eslint-disable @typescript-eslint/naming-convention */

import {
  ICommunityMessage,
  IPoll,
} from './communityMessagesTypes';
import { IUserDetails } from './userTypes';

export enum SOCKET_BROADCAST_EVENTS {
  USER_JOINED = 'user.joined',
  USER_LEFT = 'user.left',
  ROOM_MESSAGE_CREATED = 'room.message.created',
  ROOM_MESSAGE_EDITED = 'room.message.edited',
  ROOM_MESSAGE_DELETED = 'room.message.deleted',
  ROOM_MESSAGE_REACTED = 'room.message.reacted',
  ROOM_MESSAGE_POLL_VOTED = 'room.message.poll.voted',
  ROOM_NEW = 'room.new',
}

export enum SERVICE_REQUEST_SOCKET_ACTION_EVENTS {
  ROOM_JOIN = 'room.join',
  ROOM_MESSAGE_CREATE = 'room.message.create',
  ROOM_MESSAGE_SEE = 'room.message.see',
}

export enum SOCKET_ACTION_EVENTS {
  ROOM_JOIN = 'room.join',
  ROOM_MESSAGE_CREATE = 'room.message.create',
  ROOM_MESSAGE_EDIT = 'room.message.edit',
  ROOM_MESSAGE_DELETE = 'room.message.delete',
  ROOM_MESSAGE_REACT = 'room.message.react',
  ROOM_MESSAGE_POLL_VOTE = 'room.message.poll.vote',
  ROOM_MESSAGE_SEE = 'room.message.see',
}

export interface SOCKET_BROADCAST_EVENTS_MAP {
  'user.joined': {
    user: Pick<
      IUserDetails,
      '_id' | 'name' | 'email' | 'phone' | 'onboarding' | 'profilePicUrl'
    >;
  };
  'user.left': {
    user: Pick<
      IUserDetails,
      '_id' | 'name' | 'email' | 'phone' | 'onboarding' | 'profilePicUrl'
    >;
  };
  'room.message.created': {
    room: string;
    message: ICommunityMessage;
  };
  'room.message.edited': {
    room: string;
    message: ICommunityMessage;
  };
  'room.message.deleted': {
    room: string;
    message: ICommunityMessage;
  };
  'room.message.reacted': {
    room: string;
    message: ICommunityMessage;
  };
}

export interface IPollVoteReqBody {
  room: string;
  messageId: string;
  optionId: string;
  poll: string;
  undo?: boolean;
}

export interface SOCKET_ACTION_EVENTS_MAP {
  'room.join': { room: string };
  'room.message.create': {
    room: string;
    message: string;
    assets?: string[];
    threadRoot?: string;
    poll?: IPoll;
  };
  'room.message.edit': { room: string; messageId: string; message: string };
  'room.message.delete': { room: string; messageId: string };
  'room.message.see': { room: string; messageId: string };
  'room.message.react': { room: string; messageId: string; reaction: string };
  'room.message.poll.vote': IPollVoteReqBody;
}

export enum SERVICE_REQUEST_SOCKET_BROADCAST_EVENTS {
  ROOM_MESSAGE_CREATED = 'room.message.created',
}

export interface SERVICE_REQUEST_SOCKET_BROADCAST_EVENTS_MAP {
  'room.message.created': {
    room: string;
    message: ICommunityMessage;
  };
}

export interface SERVICE_REQUEST_SOCKET_ACTION_EVENTS_MAP {
  'room.join': { room: string };
  'room.message.create': {
    room: string;
    message: string;
    assets?: string[];
    threadRoot?: string;
    poll?: IPoll;
  };
  'room.message.see': { room: string; messageId: string };
}
